export class GetBulkPaymentHistory {
  static readonly type = '[BulkPaymentHistory] GetBulkPaymentHistory';
  constructor(public page = 1, public size = 100, public searchValue = '') {}
}
